module.exports = __webpack_public_path__ + "img/earthCircle.753a7d7e.png";